import React from "react";
import AppBusiness from "./appBusiness";
import "./connectors.scss";
import DatabaseCloud from "./dataBaseCloud";
import NeedToReconcile from "./needToReconcile";
import SocialConnectors from "./socialConnectors";
import SpreadsheetTxt from "./spreadsheetTxt";
import ThousandsHyaia from "./thousandsHyaia";
import WebServicesApis from "./WebServicesApis";
import Letsgo from "./letsgo";
import SafeInformation from "./safeInformation";
import DataConnectors from "./dataConnectors";
import CustomerTestimonialsConnectors from "./customerTestimonialsConnectors";



function Connectors() {
  return (
    <div className="container-connectors">
      <div className="section-data-connectors">
        <DataConnectors />
      </div>
      <div className="section-need-to-reconcile">
        <NeedToReconcile />
      </div>
      <div className="section-app-business">
        <AppBusiness />
      </div>
      <div className="section-social-connectors">
        <SocialConnectors />
      </div>
      <div className="section-database-cloud">
        <DatabaseCloud />
      </div>
      <div className="section-spreadsheet-txt">
        <SpreadsheetTxt />
      </div>
      <div className="section-web-services-apis">
        <WebServicesApis />
      </div>
      <div className="section-thousands-hyaia">
        <ThousandsHyaia />
      </div>
      <div className="section-customer-testimonials-connectors">
       
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
      <div className="section-safe-information">
        <SafeInformation />
      </div>
    </div>
  );
}

export default Connectors;
